<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<select #field class="form-control" [id]="(id === null ? name : id)" [name]="name" [disabled]="detailMode" size="3"
    [hidden]="true">
    <ng-container *ngIf="items && items.length > 0">
        <option *ngFor="let item of items; let i = index" [value]="item.id" [selected]="item.id == value"
            (click)="atualizarIndice(i)">
            <div *ngIf="this.dadosSubordinacao; then subordinacao else comum"></div>

            <ng-template #subordinacao>
                <span class="small d-block"><b>{{ item.complementar.descricaoPrincipal }}</b></span><br />
                <span class="small">{{ item.nome }}</span>
            </ng-template>

            <ng-template #comum>
                <span>{{ item.nome }}</span>
            </ng-template>
        </option>
    </ng-container>
</select>

<div class="border rounded dados overflow-auto">
    <ul *ngIf="items && items.length > 0">
        <li [ngClass]="'mt-1 rounded '  + (i === this.selectedIndex ? 'selecionado' : '')"
            *ngFor="let item of items; let i = index" [value]="item.id" (click)="atualizarIndice(i)">
            <div *ngIf="this.dadosSubordinacao; then subordinacao else comum"></div>

            <ng-template #subordinacao>
                <span class="small d-block"><b>{{
                        item.complementar.descricaoPrincipal }}</b></span>
                <span class="small">{{ item.nome }}</span>
            </ng-template>

            <ng-template #comum>
                <span class="small">{{ item.nome }}</span>
            </ng-template>
        </li>
    </ul>
</div>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>